<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs>
              <CTab  :title="$t('personList')">
<AllPersonList
    />

              </CTab>
              <CTab  :title="$t('addPerson')">

<AddPerson/>
              </CTab>

            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
import PersonList from "./PersonList";
import BTabs from "../../tabs/BTabs";
import AllPersonList from "@/views/panel/users/AllPersonList";
import AddPerson from "@/views/panel/users/AddPerson";
export default {
  name: 'Login',
  components:{
    BTabs,
    PersonList,
    AllPersonList,
    AddPerson
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

  }, watch: {

  },
  methods: {


  }
}

</script>
